module.exports = __webpack_public_path__ + "static/media/ic_input_fisdom.49518cb7.svg";